import { PlainText } from './PlainText'

export const HeadingBlock = ({ contents }: { contents: any[] }) => {
    //Add different levels of heading later
    return (
        <h1 style={{ lineHeight: '1em', margin: '0' }}>
            {contents.map((content, index) => (
                <PlainText key={index} contents={content.value} />
            ))}
        </h1>
    )
}
